export const locale = {
  lang: "fr-CA",
  data: {
    ORDER_UPSALE: {
      TITLE: "Suggestions (upsell)",
      FOR_PRODUCT: "Pour le produit",
      EMPTY: "Aucune suggestion pour ce produit.",
      ADD: "Ajouter à la commande",
      ADDED: "Ajouté à la commande",
      ADD_ERROR: "Impossible d'ajouter l'item — réessayez.",
      MATERIAL: "Matériel",
      PRODUCT: "Produit",
    },
  },
};
